const app_version = 'nutron-0.1.0';

export default {
    APP_VERSION: app_version
}